import { useSelector } from 'react-redux';
import { ButtonComponent } from '../../../UI/ButtonComponent/ButtonComponent';
import { RootState } from '../../../../redux/AppReducer';
import { convertUserLocalStorageKey, lastUrlLocalStorageKey } from '../../../../common/constants';
import './NavigationButtonsComponent.scss';

const constants = {
	loginButtonText: 'Login',
	registerButtonText: 'Sign Up',
	logOutButtonText: 'Logout',
	loginSignupText: 'Login / Sign Up',
	iirisRegisterButtonId: 'irisRegisterBtn',
	iirisLoginButtonId: 'irisLoginBtn'
};

export default function PublicMenuComponent() {
	const isLoadingBeaconUserSave = useSelector(
		(state: RootState) => state.appState.isLoadingSaveUserBeacon
	);
	const handleLogin = () => {
		localStorage.setItem(
			lastUrlLocalStorageKey,
			window.location.pathname + window.location.search + window.location.hash
		);
		document?.getElementById(constants.iirisLoginButtonId)?.click();
	};

	const handleRegister = () => {
		localStorage.setItem(
			lastUrlLocalStorageKey,
			window.location.pathname + window.location.search + window.location.hash
		);
		localStorage.setItem(convertUserLocalStorageKey, 'true');
		document?.getElementById(constants.iirisRegisterButtonId)?.click();
	};

	return (
		<div className='authentication' data-testid='authentication'>
			<div className={'buttons-section anonymous-container'} data-testid='buttons-section'>
				<ButtonComponent
					text={constants.loginButtonText}
					onClick={handleLogin}
					style={'rounded-button primary'}
					disabled={isLoadingBeaconUserSave}
				/>
				<ButtonComponent
					text={constants.registerButtonText}
					onClick={handleRegister}
					style={'rounded-button secondary renderDesktop'}
					disabled={isLoadingBeaconUserSave}
				/>
				<ButtonComponent
					text={constants.loginSignupText}
					onClick={handleLogin}
					style={'rounded-button secondary renderOnMobile'}
					disabled={isLoadingBeaconUserSave}
				/>
			</div>
		</div>
	);
}
